// @flow
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import { loggedInSelector, isUserValidatedSelector } from '../selectors';
import { PageLoader } from '../../common';

import type { ContextRouter } from 'react-router-dom';

type Props = {
  ref: string,
  children: React.Element<*> | React.Element<*>[],
  loggedIn: boolean,
  isUserValidated: boolean,
} & ContextRouter;

const UnauthenticatedRedirect = (props: Props) => {
  if (!props.isUserValidated) return <PageLoader />;
  return props.loggedIn
    ? <div>{props.children}</div>
    : <Redirect to={{ pathname: '/login', state: { to: props.location.pathname, message: 'Por favor entre ou crie sua conta para continuar' } }} />;
};

const mapStateToProps = (state, ownProps) => {
  return {
    loggedIn: loggedInSelector(state),
    isUserValidated: isUserValidatedSelector(state),
  };
};

export default withRouter(connect(mapStateToProps)(UnauthenticatedRedirect));
